import { crewsortorder } from './crewsortorder'

export function crewfun(inputData) {
  const director1 = [...inputData.Moviedirector]
  const director2 = [...inputData.Moviedirectorte]
  const director = crewsortorder(director1, director2)
  const producer1 = [...inputData.MovieProducer]
  const producer2 = [...inputData.MovieProducerTelugu]
  const producer = crewsortorder(producer1, producer2)
  const Writer1 = [...inputData.Moviewritter]
  const Writer2 = [...inputData.Moviewritterte]
  const writer = crewsortorder(Writer1, Writer2)
  const musician1 = [...inputData.Moviemusicby]
  const musician2 = [...inputData.Moviemusicbyte]
  const musician = crewsortorder(musician1, musician2)
  const Dialoge1 = [...inputData.MovieDialoge]
  const Dialoge2 = [...inputData.MovieDialogete]
  const Dialoge = crewsortorder(Dialoge1, Dialoge2)
  const screenplay1 = [...inputData.MovieScreenPlay]
  const screenplay2 = [...inputData.MovieScreenPlayTelugu]
  const screenplay = crewsortorder(screenplay1, screenplay2)
  const story1 = [...inputData.story]
  const story2 = [...inputData.storyte]
  const story = crewsortorder(story1, story2)
  const cinemato1 = [...inputData.MovieCimematographer]
  const cinemato2 = [...inputData.MovieCimematographerTelugu]
  const cinemato = crewsortorder(cinemato1, cinemato2)
  const editor1 = [...inputData.MovieEditor]
  const editor2 = [...inputData.MovieEditorte]
  const editor = crewsortorder(editor1, editor2)
  return [
    ...director,
    ...producer,
    ...writer,
    ...musician,
    ...Dialoge,
    ...screenplay,
    ...story,
    ...cinemato,
    ...editor,
  ]
}
